export default __webpack_public_path__ + "static/media/1.294f3804.jpg";